import "./simulator.scss";

const simulator = () => {
  const formatter = new Intl.NumberFormat("pt-BR", {
    style: "decimal",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  //Modifica a exibição de texto do valor requerido
  var range = document.querySelector("#slider-range");
  var value = document.querySelector("#amount");

  value.textContent = "R$ " + formatter.format(range.value);

  range.addEventListener("input", function () {
    if (this.value <= 150 || this.value == 0) {
      this.setAttribute("min", "150");
      this.setAttribute("step", "100");
    } else if (this.value < 250 || this.value == 0) {
      this.setAttribute("min", "150");
      this.setAttribute("step", "100");
    } else if (this.value >= 250 && this.value <= 30000) {
      this.setAttribute("min", "0");
      this.setAttribute("step", "250");
    }
    value.textContent = "R$ " + formatter.format(range.value);

    //Determina a largura da barra  do range
    var val =
      (this.value - this.getAttribute("min")) / this.getAttribute("max") -
      this.getAttribute("min");
    var percent = val * 100;
    document.querySelector("#slider-range-fill").style.cssText =
      "width: " + percent + "%";
  });

  //Modifica a exibição de texto da quantidade de meses
  var rangeMonth = document.querySelector("#slider-range-month");
  var valueMonth = document.querySelector("#month-amount");
  var monthAmountOutput = document.querySelector("#month-amount-output");

  valueMonth.textContent = rangeMonth.value + " meses";
  monthAmountOutput.textContent = rangeMonth.value + "x";

  rangeMonth.addEventListener("input", function () {
    if (this.value <= 6) {
      this.setAttribute("min", "6");
      this.setAttribute("step", "6");
    } else {
      this.setAttribute("min", "0");
      this.setAttribute("step", "12");
    }

    valueMonth.textContent = this.value + " meses";
    monthAmountOutput.textContent = this.value + "x";

    //Determina a largura da barra  do range
    var val =
      (this.value - this.getAttribute("min")) / this.getAttribute("max") -
      this.getAttribute("min");
    var percent = val * 100;
    document.querySelector("#slider-range-month-fill").style.cssText =
      "width: " + percent + "%";
  });

  var jsonTax =
    '{"data": {' +
    '"6": "( (0.1575 * ((1 + 0.1575) ** 6)) / (((1 + 0.1575) ** 6) - 1) * ( ${totalLoan} + (0) + (${totalLoan} * 0.38 / 100) + (0.008 * 30 * ${totalLoan} / 100) ) )", ' +
    '"12": "( (0.0594 * ((1 + 0.0594) ** 12)) / (((1 + 0.0594) ** 12) - 1) * ( ${totalLoan} + (0) + (${totalLoan} * 0.38 / 100) + (0.008 * 30 * ${totalLoan} / 100) ) )", ' +
    '"24": "( (0.038 * ((1 + 0.038) ** 24)) / (((1 + 0.038) ** 24) - 1) * ( ${totalLoan} + (0) + (${totalLoan} * 0.38 / 100) + (0.008 * 30 * ${totalLoan} / 100) ) )", ' +
    '"36": "( (0.0346 * ((1 + 0.0346) ** 36)) / (((1 + 0.0346) ** 36) - 1) * ( ${totalLoan} + (0) + (${totalLoan} * 0.38 / 100) + (0.008 * 30 * ${totalLoan} / 100) ) )", ' +
    '"48": "( (0.033 * ((1 + 0.033) ** 48)) / (((1 + 0.033) ** 48) - 1) * ( ${totalLoan} + (0) + (${totalLoan} * 0.38 / 100) + (0.008 * 30 * ${totalLoan} / 100) ) )"}}';

  var resData = JSON.parse(jsonTax);
  document.querySelector("#slider-range").value = "5000";
  document.querySelector("#slider-range-month").value = "6";

  // Calcula valor das prestações
  var loan = document.querySelector("#slider-range").value;
  var month = document.querySelector("#slider-range-month").value;
  var loanSize = eval(
    resData.data[month].replace(/\$\{totalLoan\}/g, loan)
  ).toFixed(2);

  var formatOptions = {
    style: "decimal",
    minimumFractionDigits: 2,
    currency: "BRL",
  };
  var numIntl = new Intl.NumberFormat("pt-BR", formatOptions);
  var numFormat = numIntl.format(loanSize);

  document.querySelector("#amount").textContent =
    "R$ " + formatter.format(loan);
  document.querySelector("#price-number").textContent = numFormat;

  //Atualiza os valores de acordo com o range
  //O primeiro atualiza baseado na quantidade de parcelas e o segundo no valor desejado
  var priceNumber = document.querySelector("#price-number");
  rangeMonth.addEventListener("input", function () {
    loan = document.querySelector("#slider-range").value;
    month = this.value;
    loanSize = eval(resData.data[month].replace(/\$\{totalLoan\}/g, loan));
    priceNumber.textContent = formatter.format(loanSize);
  });
  range.addEventListener("input", function () {
    loan = this.value;
    month = document.querySelector("#slider-range-month").value;
    loanSize = eval(
      resData.data[month].replace(/\$\{totalLoan\}/g, loan)
    ).toFixed(2);
    priceNumber.textContent = formatter.format(loanSize);
  });

  //Envia as requisições
  document.querySelector(".simulator-submit").onclick = function (e) {
    e.preventDefault();

    const amount = document.querySelector("#amount").innerHTML;
    const amountSanitize = amount
      .replace("R$", "")
      .replace(".", "")
      .replace(",00", "")
      .trim();

    const installments = document.querySelector("#month-amount").innerHTML;
    const installmentsSanitize = installments.replace(/\D/g, "");

    //Desativa os ranges
    // document.querySelector('#slider-range').setAttribute('disabled', 'disabled');
    // document.querySelector('#slider-range-month').setAttribute('disabled', 'disabled');

    // var newWindow = window.open('');

    // var params = encodeURIComponent(
    //   `/ecred/area-cliente/redirect-resolve?r=pay-debts&v=${loan}&p=${month}`
    // );

    location.href = `https://www.serasa.com.br/entrar?redirectUrl=%2Farea-cliente%2Fsolucoes%2Farea-credito%2Femprestimo%3Fs_desired_value%3D${amountSanitize}%26s_installment%3D${installmentsSanitize}%26utm_source%3Demprestimo`;
  };
};

export default () => {
  window.addEventListener("load", simulator);
};



// WEBPACK FOOTER //
// ./src/partials/simulator_pages/simulator.js